import { get, post } from './api';

export const getProgress = () => get('/videos/progress');
export const deleteFromQueue = data => post('/videos/abort', data);
export const socketUnsubscribe = socketId => post('/videos/unsubscribe', { socketId });
